import { axiosApi } from './axios.api';
import { apiErrorMessage } from './ApiError';

const url = `/api/onepay`;

export interface OnePaymentResponse {
  payment_url: string;
  qr_url?: string;
  qr_data?: string;
  // QR code image ready to use as <img src> — fetched server-side from qrserver.com
  qr_image?: string;
  expiry_time?: string;
  // Số tiền (VND) đã khoá vào mã QR, do backend tính từ công nợ đơn.
  // Luôn hiển thị con số này thay vì tự tính ở client, để số trên màn hình
  // không bao giờ lệch với số khách thực sự bị trừ (xem sự cố HD02410).
  amount?: number;
  payable_type: string;
  payable_id: number;
  order_code?: string;
}

export const generateOnePayUrlApi = async (
  payableType: string,
  payableId: number,
  // force=true: bỏ qua QR đang cache phía backend để tạo giao dịch OnePay mới
  // (dùng khi QR cũ đã hết hạn và cần gửi lại mã mới cho khách)
  force = false,
): Promise<OnePaymentResponse | undefined> => {
  try {
    const response = await axiosApi.post(`${url}/payment`, {
      payable_type: payableType,
      payable_id: payableId,
      ...(force ? { force: true } : {}),
    });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getOnePayQRBase64 = async (
  payableType: string,
  payableId: number,
  force = false,
): Promise<string | null> => {
  try {
    const res = await generateOnePayUrlApi(payableType, payableId, force);
    if (!res) return null;
    // qr_image là SVG data URI do server tạo sẵn (không gặp vấn đề CORS/CSP)
    return res.qr_image ?? null;
  } catch {
    return null;
  }
};
